import { Injectable } from '@angular/core';
import * as xml2js from 'xml2js';
import { apiURLs } from '../globalcontants';
import * as appApiResources from '../../shared/globalcontants';
import { CSharpRequestService } from './csharp-request.service';

export interface OdataGlobalEntity {
    OdataViewModelEntity: any;
    OdataPostModelEntity: any;
}
@Injectable({
    providedIn: 'root',
  })

  export class OdataConfigurationService {
  OdataCollection: OdataGlobalEntity;
  constructor(private csharpService: CSharpRequestService) {}
      /**
       * @method GetOdata()
       * @params None
       * @description get odatabase object creation
       */
       GetOdataGlobalCollection(): void {
         try {
          const HTTP = new XMLHttpRequest();
          const baseUrl = window.localStorage.getItem('apiUrl');
          const url = baseUrl + apiURLs.OdataInventoryManagementApi.GetMetaData;
          const _that = this;
          HTTP.open('GET', url);
          HTTP.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
          HTTP.send();
          HTTP.onreadystatechange = function (e) {
            if (this.status === 200) {
              if (e.target as XMLHttpRequest) {
                xml2js.parseString(this.response, function (err: any, result: any) {
                  if (result && result !== null && result !== 'null') {
                    const OdataGlobal = {} as OdataGlobalEntity;
                    const entitySchema = result['edmx:Edmx']['edmx:DataServices'][0].Schema;
                    const viewModelEntity = _that.getEntity(entitySchema, 'Inventory.Entities');
                    const postModelEntity = _that.getEntity(entitySchema, 'Inventory.Models');
                    const transactionViewModelEntity = _that.getEntity(entitySchema, 'Transaction.Entities');
                    const transactionPostModelEntity = _that.getEntity(entitySchema, 'Transaction.Models');
                    OdataGlobal.OdataPostModelEntity = [...postModelEntity, ...transactionPostModelEntity];
                    OdataGlobal.OdataViewModelEntity = [...viewModelEntity, ...transactionViewModelEntity];
                    _that.OdataCollection = {...OdataGlobal}
                    if (_that.csharpService.IsLoadFromApp) {
                      if (_that.OdataCollection != undefined) {
                        const settingsObj =
                        {
                          ODataCollection: JSON.stringify(_that.OdataCollection),
                          componentName: appApiResources.ComponentNameReferences.Login,
                          funcName: "SaveODataCollection",
                          Action: "SaveODataCollection"
                        };
                        _that.csharpService.RequestPOSTCSharp(appApiResources.cSharpURLs.SaveODataCollection, settingsObj, false);
                      }
                    }
                    sessionStorage.setItem(appApiResources.ODataCollection.toString(), JSON.stringify(({...OdataGlobal})));
                  }
                });
              }
            }
          };
        } catch (error) {
          console.error(error);
        }
      }

        /**
     * @method getEntity(entitySchema: Array<any>, entityName: string)
     * @input params Entity Name
     * @description split the entity name
     */
    getEntity (EntitySchema: Array<any>, EntityName: string ): Array<any> {
      const entityArray = EntitySchema.filter( x => x['$']['Namespace'] === EntityName )[0].EntityType;
      return entityArray;
    }
  }
